import { Reducer } from 'redux';
import UtilityService from '../../common/UtilityService';
import { UserActionTypes, UserActions } from '../actions/userActions'
import StorageService from '../../common/StorageService'
import configurationService from '../../services/core/configuration.service';

export interface IUserState {
    errorMessage?: string;
    isAuthenticated: boolean;

}

const initialUserState: IUserState = {
    errorMessage: '',
    isAuthenticated: false,

};

export const userReducer: Reducer<IUserState, UserActions> = (
    state = initialUserState,
    action
) => {
    if (state === initialUserState) {

    }
    switch (action.type) {
        case UserActionTypes.LOGIN_REQUEST:
            return {
                ...state,

                isAuthenticated: state.isAuthenticated,
                errorMessage: "",
            };
            break;
        case UserActionTypes.LOGIN_JWT_Receive:

            return {
                ...state,

                isAuthenticated: true,
                errorMessage: "",

            };
            break;
        case UserActionTypes.LOGIN_ERROR:
            return {
                ...state,
                errorMessage: action.message,
                isAuthenticated: false,
            };
            break;
        case UserActionTypes.LOGOUT:

            return {
                ...state,

                isAuthenticated: false,
                errorMessage: "",
            };
            break;
        default:
            return state;

    };


};




